import { createContext, useContext } from "react"

export interface TabBarContextType {
  activeKeys: string[]
  isSelected: (eventKey: string) => boolean
  onTabSelect: (eventKey: string) => void

  // Optional DnD properties (only present when enableSort=true)
  enableSort?: boolean
  onSort?: (eventKey: string, oldIndex: number, newIndex: number) => void
  hoverIndex?: number | null
}

export const TabBarContext = createContext<TabBarContextType | undefined>(
  undefined
)

export function useTabBarContext() {
  const context = useContext(TabBarContext)
  if (!context) {
    throw new Error("TabBar components must be used within TabBar.Root")
  }
  return context
}
